<template>
  <div class="view-startup-admin-resources view-dark-bg">
    <b-container class="pt-10 pb-40 pb-md-80">
      <SearchNoResults v-if="!tools.length" type="tools" />
      <b-row v-else>
        <b-col v-for="tool in tools" :key="tool.id" lg="4" md="6" class="mb-50">
          <ToolsCard :tool="tool" :type="type" />
        </b-col>
      </b-row>
      <div
        class="text-center py-60 py-md-80 py-xl-100 ml-auto mr-auto"
        style="max-width:560px"
      >
        <img src="@/assets/img/icons/feedback.svg" alt="" />
        <h4 class="py-16">Want to feature your product?</h4>
        <p class="text-gray-700">
          Post a deal for our community to drive trials of your paid product.
        </p>
        <a
          href="mailto:info@thehub.io"
          target="_blank"
          class="btn btn-outline btn-w200 mt-24"
          >Request access</a
        >
      </div>
    </b-container>
  </div>
</template>

<script>
import ToolsCard from '@/components/tools/ToolsCard'
import SearchNoResults from '@/components/search/SearchNoResults'

export default {
  name: 'ToolsPageContent',
  components: {
    ToolsCard,
    SearchNoResults
  },
  props: {
    type: String,
    tools: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.view-startup-admin-resources {
  flex: 1 1 auto;
}
</style>
